import React, { useEffect, useState } from 'react'
import "./EmployeeList.scss";
import Accordion from '../../../../components/Accordion/Accordion'
import { decryptAESID } from '../../../../utils/Encryption';
import { useParams } from 'react-router-dom';
import { useAddSGBCCorporateRepresentativeLogMutation, useLazyDeleteCorporateEmployeeByIdQuery, useLazyGetSGBCCorporateEmployeeListByIdQuery } from '../../../../app/services/Employees/employeeApi';
import AddEmployee from './components/AddEmployee';
import EditEmployee from './components/EditEmployee';
import SwalAlert from '../../../../services/swalService/SwalService';
import NoRecordFound from '../../../../components/ui/noRecordFound/NoRecordFound';
import { getAuthProps } from '../../../../lib/authenticationLibrary';

const EmployeesList = ({isEmployee,setIsEmployee,roleId} ) => {
  const { id } = useParams();
  let authData = getAuthProps();
  const { confirm } = SwalAlert();
  const editID = id ? decryptAESID(id, false) : 0
  const [employees, setEmployees] = useState([])
  const [visibleList, setVisibleList] = useState([]);
  const [show, setShow] = useState(false);
  const [showAll, setShowAll] = useState(false);
  const [isEditEmployee, setIsEditEmployee] = useState(false)
  const [selectedEmp, setSelectedEmp] = useState({})
  const [corporateMemberId, setcorporateMemberId] = useState(null)

  const [getSGBCCorporateEmployeeList, { isLoading: employeeListIsLoading, isSuccess: employeeListIsSuccess, data: employeeListData, },] = useLazyGetSGBCCorporateEmployeeListByIdQuery();
  const [deleteCorporateEmployee, { isSuccess: deleteCorporateEmployeeIsSuccess, isLoading: deleteCorporateEmployeeIsLoading, data: deleteCorporateEmployeeData, isError: deleteCorporateEmployeeError, },] = useLazyDeleteCorporateEmployeeByIdQuery();
  const [addRepresentativeLog] = useAddSGBCCorporateRepresentativeLogMutation();

  const saveLog = (actionType, message, representativeId) => {
    const logMemberId = corporateMemberId || editID;
    if (!(logMemberId > 0)) return;
    addRepresentativeLog({
      sgbcCorporateMemberId: logMemberId,
      sgbcCorporateRepresentativeId: representativeId || null,
      actionType,
      message,
      createdBy: authData.userName,
    });
  };

  const openAddemployeeModal = () => {
    setShow(!show)
  }

  const handleModalClose = () => {
    setShow(false);
    setIsEditEmployee(false);
    setSelectedEmp({});
    getSGBCCorporateEmployeeList(corporateMemberId);
  }

  const handleDeleteClick = (data) => {
    confirm('Delete?', 'Are you sure you want to delete this employee?', 'Delete', 'Cancel').then((confirmed) => {
      if (!confirmed) return;
      deleteCorporateEmployee(data?.sgbcCorporateRepresentativeId).unwrap()
        .then(() => {
          saveLog(
            "Delete",
            `Deleted employee ${data?.name} (${data?.designation || "-"})`,
            data?.sgbcCorporateRepresentativeId
          );
        })
        .catch(() => {});
    });
  };

  useEffect(() => {
    // let id = decryptAES(memberId?.toString(), false);
    if (editID > 0) {
      getSGBCCorporateEmployeeList(editID);
      setcorporateMemberId(editID)
    }
  }, [editID]);


  useEffect(() => {
    if (!employeeListIsLoading && employeeListData && employeeListIsSuccess) {
      setEmployees(employeeListData)
    }
  }, [employeeListIsLoading, employeeListData, employeeListIsSuccess]);

  useEffect(() => {
    if (showAll) {
      setVisibleList(employees);
    } else {
      setVisibleList(employees?.slice(0, 20));
    }
  }, [employees, showAll]);

  useEffect(() => {
    if (!deleteCorporateEmployeeIsLoading && deleteCorporateEmployeeData && deleteCorporateEmployeeIsSuccess) {
      getSGBCCorporateEmployeeList(corporateMemberId);
    }
  }, [deleteCorporateEmployeeIsLoading, deleteCorporateEmployeeData, deleteCorporateEmployeeIsSuccess])

  const handleEditClick = (data) => {
    setSelectedEmp(data);
    setIsEditEmployee(true);
  }

  useEffect(() => { 
    if(isEmployee){
      getSGBCCorporateEmployeeList(editID);
      setIsEmployee(false);
    }
  },[isEmployee])

  return (
    <>
      <Accordion title="Employees" buttonLabel="+ Add New Profile" clickEvent={openAddemployeeModal} isDisable={roleId === 12}>
        <div className="team-table-container employee-table">
          <table className="team-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Designation</th>
                <th>GMP Certification</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {employees?.length > 0 ?
                <>
                  {(showAll ? visibleList : visibleList.slice(0, 5))?.map((emp, index) => (
                    <tr key={index}>
                      <td className="emp-name">{emp.name}</td>
                      <td>{emp.designation}</td>
                      <td>{(emp.gmpCertification != "" && emp.gmpCertification != null) ? emp.gmpCertification : "-"}</td>
                      <td className="action-buttons">
                        {(emp.isEdit && roleId !== 12) ? (<span className="edit-profile" onClick={() => handleEditClick(emp)}> Edit Profile</span>) : (<span className="disable-Button">Edit Profile</span>)}
                        <span className="action-separator">|</span>
                        {(emp.isDelete && roleId !== 12) ? (<span className="delete-profile" onClick={() => handleDeleteClick(emp)}>Delete</span>) : (<span className="disable-Button">Delete</span>)}
                      </td>
                    </tr>
                  ))}
                </>
                :
                <tr>
                  <td colSpan={100}>
                    <NoRecordFound />
                  </td>
                </tr>
              }
            </tbody>
          </table>
          {employees?.length > 5 && <div className="load-more-btn"
            onClick={() => setShowAll((prev) => !prev)}
          >
            {showAll ? "Load Less" : "Load More"}

          </div>}
        </div>
       
      </Accordion>
        {show && <AddEmployee show={show} setShow={setShow} id={corporateMemberId} closeModal={handleModalClose} onLog={saveLog}/>}
        {isEditEmployee && <EditEmployee show={isEditEmployee} id={corporateMemberId} closeModal={handleModalClose} employee={selectedEmp} onLog={saveLog}/>}
    </>
  )
}

export default EmployeesList
